import { FC, useContext } from "react";

import CheckCircle from "@icons/CheckCircle";
import { Flex } from "@shared-ui-components/Flex";
import Colors from "@constants/Colors";

import LocationContext from "@context/location/locationContext";
import { message } from "@src/constants";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";
import ShowSuccessToastContext from "@context/ShowSuccessToast/showSuccessToastContext";
import { NotificationCountType } from "@context/NotificationCount/notificationCountContext";
import {
  FooterNotificationCount,
  NotificationButtonWrapper,
  NotificationFooterText,
  NotificationFooterWrapper,
} from "./style";
import { updateAllNotificationRead } from "./helper";

interface NotificationFooterType {
  count: number;
  notificationCountStateSetState: React.Dispatch<
    React.SetStateAction<NotificationCountType>
  >;
}

const NotificationFooter: FC<NotificationFooterType> = ({
  count,
  notificationCountStateSetState,
}) => {
  const [{ locationState }] = useContext(LocationContext);

  const { property, store, revenueCenter, date } = locationState;

  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);

  const [{ showSuccessToastSetState }] = useContext(ShowSuccessToastContext);

  const disableCondition = Number(count) === 0 || count === null;

  const updateAllNotificationReadHandler = async () => {
    if (disableCondition) return;
    const filter: FilterType = {
      property,
      store,
      rvc: revenueCenter,
      date,
    };

    const res = await updateAllNotificationRead(filter);
    if (!res.error) {
      showSuccessToastSetState({
        successMessage: "",
        successTitle: "All Notification Marked as Read",
        open: true,
      });
      notificationCountStateSetState({ count: res?.data });
    } else {
      showErrorToastSetState({
        errorMessage: res?.error || "",
        errorTitle: message.ERROR_MESSAGE,
        open: true,
      });
    }
  };

  return (
    <NotificationFooterWrapper>
      <NotificationButtonWrapper
        onClick={updateAllNotificationReadHandler}
        disable={disableCondition}
      >
        <Flex gap="6">
          <CheckCircle
            color={disableCondition ? Colors.primarygray_300 : Colors.primary}
          />
          <NotificationFooterText disable={disableCondition}>
            Mark All As Read
          </NotificationFooterText>
        </Flex>
      </NotificationButtonWrapper>
      <FooterNotificationCount>{`${count || 0} New`}</FooterNotificationCount>
    </NotificationFooterWrapper>
  );
};

export default NotificationFooter;
